// src/context/AppConfgContext.js
import React, { createContext, useEffect, useState } from 'react'
import { variants } from '../constants/variant'
import { useStore } from '../store'
import { parseBooleanObjectValues } from '../helpers/general'
import ConfigurationInvalidSplash from '../components/ConfigurationInvalidSplash'
import { isBlockedAnalyticsProperty } from '../analytics/helpers'

// Create the context
export const AppConfigContext = createContext({})

// Create a context provider component
export const AppConfig = ({ children }) => {
  const [config, setConfig] = useState(null)
  const { setConfig: setStoreConfig, data } = useStore()

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)

    const { variant: variantSearchParam, ...searchParam } = Object.fromEntries(searchParams)

    const configVariant = process.env.REACT_APP_VARIANT || variantSearchParam

    let variant = Object.values(variants).find((v) => v === configVariant) 

    // Mimics

    let mimicVariant;

    if(variant === variants.ev){
      mimicVariant = variants.ev
      variant = variants.sw
    }

    const config = {
      mimicVariant,
      variant: variant,
      isCTFApp: variant === variants.ctf,
      isSWApp: variant === variants.sw,
      isSFApp: variant === variants.sf,
      isEWApp: variant === variants.ew,
      isPDApp: variant === variants.pd,
      isOfficesApp: variant === variants.of,
      isBrodskyApp: variant === variants.br,
      isWideMode:
        variant === variants.br ||
        variant === variants.of ||
        variant === variants.sw ||
        variant === variants.ctf ||
        variant === variants.ew ||
        variant === variants.pd,
      ...searchParam,
      searchParams: { ...searchParam },
      block_analytics: searchParam.block_analytics || isBlockedAnalyticsProperty(searchParam.property)
    }

    const parsed = parseBooleanObjectValues(config)

    setConfig(parsed)
    setStoreConfig(parsed)

    if (parsed.variant === variants.sw || parsed.variant === variants.ev) {
      document.documentElement.style.setProperty('--brand-color', '#4964E0')
      document.title = 'Staging widget - SparX'
      return
    }

    if (parsed.variant === variants.ew) {
      document.documentElement.style.setProperty('--brand-color', '#3262AC')
      document.title = 'Staging widget - SparX'
      return
    }

    if (parsed.variant === variants.of) {
      document.documentElement.style.setProperty('--brand-color', '#0079BB')
      document.title = 'Offices - SparX'
      return
    }

    if (parsed.variant === variants.br) {
      document.documentElement.style.setProperty('--brand-color', '#000000')
      document.body.style.setProperty('font-family', 'Acumin Pro Wide')
      // document.documentElement.style.setProperty('--heading-font', 'Druk Text')
      document.title = 'Brodsky - SparX'
      return
    }

    if (parsed.variant === variants.sf) {
      document.documentElement.style.setProperty('--brand-color', '#000000')
      // document.documentElement.style.setProperty('--heading-font', 'Druk Text')
      document.title = 'Sforma - SparX'
      return
    }

    document.title = 'Cort Widget App'
  }, [])

  return (
    <AppConfigContext.Provider value={{...config, set: param => {
      setConfig(
        {
          ...config, 
        ...param
        }
      )
    }}}>
      {config ? config.variant ? children : <ConfigurationInvalidSplash /> : null}
    </AppConfigContext.Provider>
  )
}

